//--------------------------------- Cart ---------------------------------
// Check for free shipping text
function check_shipping(total_price){
	let shipping_text = '';
	let currencyValue = $('#currency_form .btn-select-input').val();
	if(currencyValue == 'GBP'){
		if(total_price >= 700){
			shipping_text = '';
		} else {
			shipping_text = '';
		}
	} else if(currencyValue == 'EUR'){
		if(total_price >= 5500){
			shipping_text = '';
		} else {
			shipping_text = '';
		}
	}
	$('.shipping_text').html(shipping_text);
}


function disable_enable(element, fewSeconds){
	var btn = element;
	var fewSeconds = fewSeconds;
	btn.prop('disabled', true);
	setTimeout(function(){
		btn.prop('disabled', false);
	}, fewSeconds*1000);
}

// Cart
function cart() {
  jQuery.getJSON('/cart.js', function(cart) {
		// console.log(cart);
		//$('#cart_footer').append(JSON.stringify(cart.items))
		$('#cart-note').text(cart.note);

		var cart_items = cart.items;
		var quantity  = 0;
		var new_total = 0;
    for(var i = 0; i < cart_items.length; i++) {
			var item = cart_items[i];
			//console.log(item);
			console.log(new_total)
			var price = ((cart_items[i].final_line_price/100)).toFixed(2);;
			var pos = i + 1;
			$(".charge-input-" + pos).text("£" + price);

			// Create new total as cart doesn't contain compare at price
			if(item.product_id == 6122666721472 ||   item.product_id == 6585265946816 || item.product_id == 6585265914048){
				new_total += (item.final_line_price / 100) * 75;
			} 
			else if(  item.product_id ==  6592269713600 || item.product_id ==  6592271483072  || item.product_id == 6585193038016  ){
				if( cart_items[i].properties.interval_unit != undefined ){
					new_total += (item.final_line_price / 100) *85;
				} 
				else{
					new_total += item.final_line_price ;
				}
			}
			else {
				new_total += item.final_line_price ;
			}

			// Output flavour images on orders in the cart
      $.each(item.properties, function(key, value) {
				if(key.indexOf('flavour') > -1 && key.indexOf('_variant_id') <= -1){
					$('.cart-item').each(function( index ) {
						itemKey = item.key.replace(':','_');
            if($(this).attr('id') == itemKey){
// 							console.log(key + ' : ' + value);   // Order properties keys and values
              var flavour = 'flavour-full_' + value.replace(/ Biltong/g,'').replace(/ /g,'_').replace(/!/g,'').toLowerCase() + '.png';
							$('#'+itemKey).find('.box_image_wrapper').append('<img src="//cdn.shopify.com/s/files/1/0063/8133/8722/files/'+flavour+'?135003" class="cart_image" />');
            }
          });
				}
				
			});

			if(item.product_type == 'Wholesale'){
				quantity += item.quantity
			}
		}

		if(quantity > 1){
			if(quantity >= 1 && quantity < 4){
				// disable checkout button
				$('button[name="checkout"]').prop('disabled', true);
				$('.shipping_text').html('Please add a minimum of <strong>4</strong> wholesale items');
				$('.shipping_text_2').html('');
			} else{
				$('.shipping_text').html('');
				$('.shipping_text_2').html('');
				$('button[name="checkout"]').prop('disabled', false);
			}
		} else {
			check_shipping(cart.total_price);
		}


		//console.log('New Total: ' + (new_total/100).toFixed(2));

		// Set total price (works with currency change)
		$('.subtotal .total_price').text((new_total/100).toFixed(2));
	});
}

// Update cart
function update_cart() {
	// Automate total price in cart
	if($('body').is('#order-confirmation')){
		// For each plus/minus on quantity
		$('body').delegate('.button-wrapper button', 'click', function(e) {


			// Set variables for ID and Quantity
			var id = $(this).parent().parent().data('variant-id');
			var quantity = $(this).parent().parent().find('input.quantity').val();

			// Update cart by passing in ID and the quantity
			CartJS.updateItemById(id, quantity);

			// Disable button
			disable_enable($(this), 0.5);

			// Calculate new price
			setTimeout(function(){
				jQuery.getJSON('/cart.js', function (cart) {

					var cart_items = cart.items;
					var quantity  = 0;
					var new_total = 0;
					for(var i = 0; i < cart_items.length; i++) {
						var item = cart_items[i];
						var price = ((cart_items[i].final_line_price/100)).toFixed(2);
						var pos = i + 1;
						$(".charge-input-" + pos).text("£" + price);

						// Create new total as cart doesn't contain compare at price
						if(item.product_id == 6122666721472 || item.product_id == 6585265946816 || item.product_id == 6585265914048){
							new_total += (item.final_line_price / 100) * 75;
						} 
						else if(  item.product_id ==  6592269713600 || item.product_id ==  6592271483072  || item.product_id == 6585193038016 ){
							if( cart_items[i].properties.interval_unit != undefined ){
								new_total += (item.final_line_price / 100) * 85;
							}
							else{
								new_total += item.final_line_price ;
							}
						}
						else {
							new_total += item.final_line_price;
						}

						if(item.product_type == 'Wholesale'){
							quantity += item.quantity
						}
					}

					if(quantity > 1){
						if(quantity >= 1 && quantity < 4){
							// disable checkout button
							$('button[name="checkout"]').prop('disabled', true);
							$('.shipping_text').html('Please add a minimum of <strong>4</strong> wholesale items');
							$('.shipping_text_2').html('');
						} else{
							$('.shipping_text').html('');
							$('.shipping_text_2').html('');
							$('button[name="checkout"]').prop('disabled', false);
						}
					} else {
						check_shipping(cart.total_price);
					}

					$('.subtotal .total_price').text((new_total/100).toFixed(2));
				});
			}, 1500);
		});
	}
}

	//check if subscription boxes exist. If not, remove trial box
// 	function trialBoxRemoval(){
// 		if( window.location.pathname == "/cart"){
// 			appendLoading();
// 			jQuery.getJSON('/cart.js', function (cart) {
	
// 				var cart_items = cart.items;
// 				var subscriptionExist = false;
// 				var trial_box = false;
// 				if( sessionStorage.subscriptionAdded != "true"){
// 					sessionStorage.setItem('subscriptionAdded', "false");
// 				}
// 				for(var i = 0; i < cart_items.length; i++) {
// 					var item = cart_items[i];
// 					if( item.product_id == 6696095547584 || item.product_id == 6696097710272 || item.product_id == 6696099217600 || item.product_id == 6696095547584 || item.product_id == 6696273445056 || item.product_id == 6696273674432|| item.product_id == 6689746747584 || item.product_id ==6684545220800 ){
// 						subscriptionExist = true;
// 						sessionStorage.subscriptionAdded = "true";
// 					}
// 					else if( item.product_id == 6665162555584 ){
// 						trial_box = true;
// 					}
// 				}
// 				if( subscriptionExist == false && window.location.pathname == "/cart" && sessionStorage.subscriptionAdded == "true" ){
// 					CartJS.removeItemById(39783753449664);
// 					sessionStorage.subscriptionAdded= "false";
// 					setTimeout( function(){window.location.reload()},500);
	
// 				}
// 				else if( subscriptionExist == true && window.location.pathname == "/cart" && trial_box == false   ){
// 					var selected_flavours_trial = {};
// 					selected_flavours_trial["flavour_1"] = "The Original"
// 					selected_flavours_trial["flavour_2"] = "Chilli Chutney"
// 					selected_flavours_trial["flavour_3"] = "Peri Peri"
// 					selected_flavours_trial["flavour_4"] = "Drywors"
// 					selected_flavours_trial["flavour_1_variant_id"] = "16299959812194"
// 					selected_flavours_trial["flavour_2_variant_id"] = "16299647008866"
// 					selected_flavours_trial["flavour_3_variant_id"] = "16300022464610"
// 					selected_flavours_trial["flavour_4_variant_id"] = "16299561484386"
// 					CartJS.addItem(39783753449664, 1, selected_flavours_trial);
// 					setTimeout( function(){window.location.reload()},500);
// 				}
// 				$(".overlay_buy").remove();
// 		});	
// 		}
// }
	
	// Update cart count header when items are added/removed
	$(document).on('cart.requestComplete', function(event, cart) {
		if(cart.item_count > 0){
			$('.site-header__cart-count').css('opacity','1');
			$('.site-header__cart-count span.count').html(cart.item_count);
		} else {
			$('.site-header__cart-count').css('opacity','0');
		}
	});


function checkTextAreaMaxLength(textBox, e) { 
	// var maxLength = parseInt($(textBox).data("length"));
	var maxLength = parseInt($(textBox).attr('maxlength'));
	if (!checkSpecialKeys(e)) { 
		if (textBox.value.length > maxLength - 1) textBox.value = textBox.value.substring(0, maxLength); 
	} 
	$(".char-count").html(maxLength - textBox.value.length);
	return true; 
}

function checkSpecialKeys(e) {
	if (e.keyCode != 8 && e.keyCode != 46 && e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40){
		return false; 
	} else{
		return true;
	}
}

function add_gift_card() {
	$("body").delegate('#gift-note', 'change', function(e) {
    if(this.checked) {
			let giftNoteId = $('#gift-note').data('id')
			let giftNoteMessage = $('#CartSpecialInstructions').val()

			// console.log(giftNoteId)
			// console.log(giftNoteMessage)

			if(giftNoteMessage.trim()){
				CartJS.addItem(giftNoteId, 1);
				CartJS.setNote(giftNoteMessage);
				window.setTimeout(function (){
					location.reload(true);
				}, 500);
			} else {
				// window.alert('Please Add a message for your gift note');
				var modal_name = 'gift-note1';
				window.setTimeout(function (){
					MicroModal.show(modal_name, {
						onShow: function(modal){console.info('${modal.id} is shown')}, // [1]
						onClose: function(modal){console.info('${modal.id} is hidden')}, // [2]
						disableScroll: true, // [5]
						disableFocus: false, // [6]
						awaitCloseAnimation: false, // [7]
						debugMode: true // [8]
					})
				}, 100);
				$(this).prop("checked", false);
			}
    }
	});
	
	$(".char-count").html($('#CartSpecialInstructions').attr('maxlength'));
	$(".max-char-count").html('/'+$('#CartSpecialInstructions').attr('maxlength'));

	$("#CartSpecialInstructions").on("keyup",function(event){
		checkTextAreaMaxLength(this,event);
	});
}

//removes duplucates in arrays
function removeDups(names) {
	let unique = {};
	names.forEach(function(i) {
	  if(!unique[i]) {
		unique[i] = true;
	  }
	});
	return Object.keys(unique);
  }

function openBoxCart(){
	jQuery.getJSON('/cart.js', function (cart) {
		var cart_items = cart.items;
		var the_key = []
		var variant_id = []
		for(var i = 0; i < cart_items.length; i++) {
			if( cart_items[i].id != 39285551202496){
				if( cart_items[i].properties.open_box_key != undefined){
					the_key.push(cart_items[i].properties.open_box_key);
					variant_id.push(cart_items[i].id)
				}
			}

		}
		console.log(the_key)
		unique_key = removeDups(the_key);
		console.log(unique_key)
		$('.open-box-remove').on("click", function(e){
			var key = $(this).attr("data-open-key-remove");
			var updateVar =[];
			jQuery.getJSON('/cart.js', function (cart) {
				var cart_items = cart.items;
				var dataId = { updates: {} };
				for( var i = 0; i < cart_items.length; i++){
					if( cart_items[i].id != 39285551202496){
					if(cart_items[i].properties.open_box_key == key){
						dataId.updates[cart_items[i].id] = 0
						x = i + 1;
						updateVar.push(x)
					}
				}
				}
				appendLoading();
				for( var i = 0; i < updateVar.length; i++){
					var t = updateVar.length - 1 - i;
					CartJS.removeItem(updateVar[t]);
					console.log(updateVar[t])
				}
				setTimeout( function(){
					window.location.reload()},2000)
				// jQuery.ajax({
				// 	type: 'POST',
				// 	url: '/cart/update.js',
				// 	async: false,
				// 	data: dataId,
				// 	dataType: 'json',
				// 	success: function() { 
				// 		console.log(dataId)
				// 		// setTimeout(function(){window.location.reload()},2500);
				// 	}
				//   });


			});
		})
		for( var i = 0; i < unique_key.length; i++ ){
			console.log('[data-open-key="' + unique_key[i] + '"] .adjust-plus')
			$('[data-open-key="' + unique_key[i] + '"] .adjust-plus').on("click", function(e){
				var key = $(this).attr("data-key-id-plus");
				console.log(key)
				$("[data-open-key='" + key + "'] [data-open-id-plus='main'] .adjust-plus").click()
				console.log("[data-open-key='" + key + "'] [data-open-id-plus='main'] .adjust-plus")
			})
			$('[data-open-key="' + unique_key[i] + '"] .adjust-minus').on("click", function(e){
				var key = $(this).attr("data-key-id-minus");
				console.log(key)
				$("[data-open-key='" + key + "'] [data-open-id-plus='main'] .adjust-minus").click()
				console.log("[data-open-key='" + key + "'] [data-open-id-plus='main'] .adjust-minus")
			})
			
		}


	});
}

// function giftCard(){
// 	jQuery.getJSON('/cart.js', function (cart) {
// 		var cart_items = cart.items;
// 		for(var i = 0; i < cart_items.length; i++) {
// 			if( cart_items[i].product_id == 4462304395362){
// 				$("#gift_card_checkbox").prop("checked", true);
// 			}
// 		}
// 		$("#gift_card_checkbox").change(function(){
// 			if( $("#gift_card_checkbox").prop("checked") == true){
// 				CartJS.addItem("4462304395362", "1")
// 			}
// 		})

// });
// }

function giftCardCheck(){
	jQuery.getJSON('/cart.js', function (cart) {
		var cart_items = cart.items;
		var gift_note = false;
		if( cart_items.length == 1 && cart_items[0].id == 39285551202496){
			CartJS.removeItemById("39285551202496", {
				"success": function(data, textStatus, jqXHR) {
					window.location.reload();
				} 
			});
		}
		for(var i = 0; i < cart_items.length; i++) {
			if( cart_items[i].id == 39285551202496){
				gift_note = true;
			}
		}
		console.log(gift_note)
		if( gift_note == false){
			clearGift()
		}
		$("#cart-note").text( cart.attributes["G"])
	
	});
	setTimeout( function(){
		$(".gift_card_button").css("display", "block")
	},500)



}

function clearGift(){
	setTimeout( function(){
		CartJS.setAttributes({
			"G": ""
		});
	},1000)
}

function GiftCard1(event){
		event.preventDefault
		//check if gift note already exists in cart
		jQuery.getJSON('/cart.js', function (cart) {
			var cart_items = cart.items;
			var gift_note = false;
			for(var i = 0; i < cart_items.length; i++) {
				if( cart_items[i].id == 39285551202496){
					gift_note = true;
				}
			}
			//make sure message is not blank
			if( $.trim($("#CartSpecialInstructions").val()).match(/([a-zA-Z])+([ -~])*/) == null ){
				$(".message_error").remove();
				$("#error_gift").append("<div class='message_error'>Please add a message to add a gift note to cart</div>")
			}
			else{
				//add gift note to cart using attributes
				CartJS.setAttributes({
					"G": $('#CartSpecialInstructions').val()
				}, {
					"success": function(data, textStatus, jqXHR) {
						if( gift_note == true ){
							//if not already exists, just reload the page
							setTimeout( function(){
							window.location.reload();
							},100);
						}
						else{
							//if note doesn't exist add it to the cart
							setTimeout( function(){
							jQuery.post('/cart/add.js', {
								items: [
								  {
									quantity: 1,
									id: 39285551202496
								}]},100);

								setTimeout(function(){
									window.location.reload()
								},1500)
					
						})
						}
					}
				}
				);
			}
  });
}

// function estimatedDate(){
// 	jQuery.getJSON('/cart.js', function (cart) {
// 		var cart_items = cart.items;
// 		for(var i = 0; i < cart_items.length; i++) {
// 			if( cart_items[i].product_id == 6689746747584	 || cart_items[i].product_id == 6684545220800 || cart_items[i].product_id == 6696097710272 
// 				|| cart_items[i].product_id == 6696095547584 || cart_items[i].product_id == 6696099217600 || cart_items[i].product_id == 6696273674432 ){
// 				var weekNum = cart_items[i].properties.shipping_interval_frequency;
// 				var todayDate = Date.now();
// 				console.log(todayDate);
// 				console.log(weekNum)
// 				//604800 (1 week in seconds) times weeks chosen by customer
// 				var deliveryDate = 604800000 * parseInt(weekNum);
// 				deliveryDate = deliveryDate + todayDate;
// 				deliveryDate = new Date(deliveryDate);
// 				deliveryDate = deliveryDate.toLocaleString('en-GB');
// 				deliveryDate = deliveryDate.split(',')[0];
// 				console.log(deliveryDate)
// 				var pos = i + 1;
// 				$(".estimated-date-input-" + pos).append(deliveryDate)
// 				var price = ((cart_items[i].final_line_price/100)).toFixed(2);
// 			}
// 		}
// 	});
// }

//check for old box - if exist remove it
function oldBoxCheck(){
	jQuery.getJSON('/cart.js', function (cart) {
		var cart_items = cart.items;
		for(var i = 0; i < cart_items.length; i++) {
			if( cart_items[i].product_id == 6183000735936 || cart_items[i].product_id == 1749094793314 || cart_items[i].product_id == 1749090762850 ||
			cart_items[i].product_id == 1749040660578 || cart_items[i].product_id == 1749049475170|| cart_items[i].product_id == 1749088108642 ||
			cart_items[i].product_id == 6584060248256 || cart_items[i].product_id == 1749097447522){
				if( Object.keys(cart_items[i].properties).length == 0){
					CartJS.removeItemById(cart_items[i].id)
				}
			} 
		}
	});
}

function appendLoading(){
	$("body").append('<div class="overlay_buy"><div class="overlay_contents"><img src="https://cdn.shopify.com/s/files/1/0063/8133/8722/files/m-eat-loader.gif?v=1613573662"><div class="text-container"><p>Loading</p> </div></div></div>');
}

function checkCartStock(){
	jQuery.getJSON('/cart.js', function (cart) {
		var cart_items = cart.items;
		for( var i = 0; i < cart_items.length; i++){
			var stock = true;
			var stock_exist = true
			var product_quantity = cart_items[i].quantity;
			$.each(cart_items[i].properties, function(key, value) {
				if(key.indexOf('flavour') > -1 && key.indexOf('_variant_id') > -1){
					//check if there is any more stock that you can add
					var variant_id = value;
					var quantity = $("span[data-variant="+variant_id+"]").attr("data-quantity");
					quantity = parseInt(quantity);
					var new_qty = quantity - parseInt(product_quantity) - 1;
					$("span[data-variant="+variant_id+"]").attr("data-quantity", new_qty );
					console.log("span[data-variant="+variant_id+"]")
					if( new_qty < 0 ){
						stock = false;
					}
					//out of stock text
					var quantity = $("span[data-dummy-variant="+variant_id+"]").attr("data-quantity");
					quantity = parseInt(quantity);
					var new_qty = quantity - parseInt(product_quantity);
					$("span[data-dummy-variant="+variant_id+"]").attr("data-quantity", new_qty );
					console.log("span[data-dummy-variant="+variant_id+"]")
					console.log(new_qty)
					if( new_qty < 0 ){
						stock_exist = false;
					}
				}
			});

			console.log(stock)
			if( stock == false ){
				// $(".box_size").eq(i).append("<p>Out of Stock</p>")
				$(".adjust-plus").eq(i).attr("disabled", "disabled");
			}
			if( stock_exist == false ){
				$(".cart-item-product").eq(i+1).append("<p class='out-stock ofs-'"+i+" style='color: red;'>Out of Stock</p>");
				$('[type="submit"]').attr("disabled", "disabled");
			}

		}
	
	});
}

function buttonForStock(plusMinus, i){
	console.log($(this).attr("data-order"));
	jQuery.getJSON('/cart.js', function (cart) {
		var cart_items = cart.items;
			var stock = true;
			var stock_exist = true
			$.each(cart_items[i].properties, function(key, value) {
				if(key.indexOf('flavour') > -1 && key.indexOf('_variant_id') > -1){
					//check if there is any more stock that you can add
					var variant_id = value;
					var quantity = $("span[data-variant="+variant_id+"]").attr("data-quantity");
					quantity = parseInt(quantity);
					if( plusMinus == "plus"){
						var new_qty = quantity - 1;
					}
					else{
						var new_qty = quantity + 1;
					}
					$("span[data-variant="+variant_id+"]").attr("data-quantity", new_qty );
					new_qty = parseInt(new_qty)
					console.log(stock);
					console.log( new_qty)
					stock = true;
					if( new_qty < 0 ){ 
						stock = false;
					}

					var quantity = $("span[data-dummy-variant="+variant_id+"]").attr("data-quantity");
					quantity = parseInt(quantity);
					if( plusMinus == "plus"){
						var new_qty = quantity - 1;
					}
					else{
						var new_qty = quantity + 1;
					}
					$("span[data-dummy-variant="+variant_id+"]").attr("data-quantity", new_qty );
					if( new_qty < 0 ){
						stock_exist = false;
					}
			}
		});
		console.log(stock)
		if( stock == false ){
			// $(".box_size").eq(i).append("<p>Out of Stock</p>")
			$(".adjust-plus").eq(i).attr("disabled", "disabled");
		}
		else{
			$(".adjust-plus").eq(i).prop("disabled", false);
		}
		$(".out-stock").remove();
		if( stock_exist == false ){
			$(".cart-item-product").eq(i+1).append("<p class='out-stock ofs-'"+i+" style='color: red;'>Out of Stock</p>")
		}
		else{
			$('[type="submit"]').prop("disabled", false);
		}
		

	});
}

//Load all above functions
$(document).ready(function($){
	cart();
	update_cart();
	add_gift_card()
	openBoxCart();
	oldBoxCheck();
	setTimeout( function(){giftCardCheck()},500);
	checkCartStock();
	modalClose();





	// Add shipping span if currency in GBP
	if($('#currency_form .btn-select-input').val() == 'GBP' || $('#currency_form .btn-select-input').val() == 'EUR'){
		$('.cart-checkout').prepend('<span class="shipping_text"></span>');
	}

	// Iterate through reviews and display randomly on cart page
  for ( var i = 0; i < reviews.review.length; i++) {
    random_int = Math.floor(Math.random() * reviews.review.length);
    color_int = Math.floor(Math.random() * 2);
    review = reviews.review[random_int];
    $('#cart_review .review_text').text(review.review_text);
    $('#cart_review .review_name').text(review.review_name);
    $('#cart_review').addClass('r_'+color_int);
    break;
  }


  $(".adjust-minus").on("click", function(e){
	var order = $(this).attr("data-order");
	order = parseInt(order) - 1;
	setTimeout(function(){buttonForStock("minus", order)},1000)
  })
  $(".adjust-plus").on("click", function(e){
	var order = $(this).attr("data-order");
	order = parseInt(order) - 1;
	setTimeout(function(){buttonForStock("plus", order)},1000)
  })
});

function modalClose(){
	$(".close").on("click", function(){
		$(".modal__overlay").click();
	})
}


